var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-signup"},[_vm._t("title"),_c('md-card-content',{staticClass:"px-4"},[_c('div',{staticClass:"md-layout"},[_vm._t("content")],2)]),_c('md-card-actions',[_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }